/* @flow strict */

import * as React from 'react';
import Switcher from '/client/src/components/switcher';

type PropsType = {
  className?: string,
  headerClassName?: string,
  title: string | React.Node,
  children: React.Node,
  status?: boolean,
  onChange?: () => void,
  dataTestid?: string
};

const CollapsedPanel = ({
  className,
  headerClassName,
  title,
  children,
  status,
  onChange,
  dataTestid
}: PropsType): React.Element<typeof React.Element> => {
  const [active, setActive] = React.useState(status || false);

  React.useEffect(() => {
    setActive(!!status);
  }, [status]);

  return (
    <div
      className={`panel panel-default panel-page no-border ${className}`}
      data-testid={!!dataTestid ? dataTestid : 'CollapsedPanel'}
    >
      {/* eslint-disable-next-line max-len */}
      <div className={`panel-heading panel-heading-gray ${!active ? 'deactive' : ''} ${!headerClassName ? headerClassName : ''}`}>
        <div className="panel-title">
          <Switcher
            className='form-switcher pull-left'
            id={title.replace(/ /g, '')}
            index={title.replace(/ /g, '')}
            checked={active}
            onCallback={() => {
              setActive(!active);

              if (onChange) {
                onChange(!active);
              }
            }}
            label={title}
          />
        </div>
      </div>
      {active &&
        <div className="panel-body">
          {children}
        </div>
      }
    </div>
  );
};

export default CollapsedPanel;
